import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 15000 });

export const enviarContacto = (data) => api.post("/contact", data);
export const agendarLlamada = (data) => api.post("/call-requests", data);
export const solicitarPresupuesto = (data) => api.post("/presupuestos", data);
export const enviarResena = (data) => api.post("/resenas", data);
export const listarResenas = () => api.get("/resenas");
